import { render, staticRenderFns } from "./TrainDetailsBlock.vue?vue&type=template&id=76ba00f8"
import script from "./trainDetailsBlock.ts?vue&type=script&lang=js&external"
export * from "./trainDetailsBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports